import Sortable from 'sortablejs';

$(document).on('turbolinks:load', function(){
  // Sortable for lists (legacy)
  var el = document.getElementById('sortable');
  if (el) { // Check if the element exists
    var sortable = Sortable.create(el, {
      handle: '.item',
      animation: 150,

      onUpdate: function (evt) {
        var listId = $('#sortable').data('id')

        var orderLists = []
        $('#sortable .item').each(function(i, e) {
          orderLists.push($(e).data('id'))
        })

        $.ajax({
          url: '/lists/' + listId,
          type: 'PUT',
          data: { ids: orderLists }
        });
      },
    });
  }

  // Sortable for collections
  var collectionEl = document.getElementById('sortable-collections');
  if (collectionEl) {
    var sortableCollection = Sortable.create(collectionEl, {
      handle: '.item',
      animation: 150,

      onUpdate: function (evt) {
        var collectionId = $('#sortable-collections').data('id')

        var orderCards = []
        $('#sortable-collections .item').each(function(i, e) {
          orderCards.push($(e).data('id'))
        })

        $.ajax({
          url: '/collections/' + collectionId,
          type: 'PUT',
          data: { card_ids: orderCards },
          headers: {
            'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
          }
        });
      },
    });
  }
})
